module.exports = __webpack_public_path__ + "static/media/emergency-plan-2.6855725.68557254.svg";